import "./index.css";
import React, { Fragment, createRef } from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import Package from "../../components/Package";
import Popup from "./components/Popup";
import EditPackage from "./components/EditPackage";
import { TerritoryOptions } from "../../Constants/retailer";
import MapViewer from "../../components/MapViewer";
import ProductCarousel from "../Products/components/ProductCarousel";
import ConfirmationModal from "../../components/ConfirmationModal";
import { getFilePath, uploadFile } from "../../Utils/utils";
import { IMAGE_UPLOAD, YOUTUBE_URL } from "../../Constants/types";

class SuperProducts extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      packages: [],
      selectedPackage: null,
      brandPrimaryHex: "#faff87",
      isMapOpen: false,
      hoveredLocation: { lat: null, lng: null, title: "" },
    };
    this.sliderRef = createRef();
    this.path = `packages/0/images`;
  }
  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      let packages = [];
      Firebase.getEcoPackages((res) => {
        let packages_keys = Object.keys(res);
        packages = Object.values(res);
        let array = [];
        packages.map((item, index) => {
          item.id = packages_keys[index];
          const { order } = item;
          array[order] = item;
        });
        this.setState({ loading: false, packages: array });
      });
    }
  }
  getFor = (renter_owner) => {
    switch (renter_owner) {
      case "renter":
        return 1;
      case "owner":
        return 2;
      case "both":
        return 0;
      default:
        return 0;
    }
  };
  getContents = (contents) => {
    let str = "";
    contents.map((item) => {
      str += "-" + item + "\n";
    });
    return str;
  };

  deleteUploadedMedia = async (selectedPackage) => {
    const deletePromises = selectedPackage.media.map((item) => {
      if (item && item.mediaType !== YOUTUBE_URL) {
        const path = getFilePath("packages", item.mediaUrl, item.mediaType);
        return Firebase.deleteFile(path);
      }
    });
    await Promise.all(deletePromises);
  };

  removePackage = async () => {
    const { selectedPackage } = this.state;
    if (!selectedPackage) return;

    try {
      await this.deleteUploadedMedia(selectedPackage);

      if (selectedPackage.productLogo) {
        const path = getFilePath(
          "packages",
          selectedPackage.productLogo,
          IMAGE_UPLOAD
        );
        await Firebase.deleteFile(path);
      }

      Firebase.deleteEcoPackageById(selectedPackage.id).catch(() => {
        alert("Something went wrong!");
      });
    } catch (e) {
      console.error("Error removing package", e);
    }
  };

  addPackage = async (data) => {
    this.setState({ loading: true });

    const packageData = {
      caption: data.caption,
      description: data.description,
      price: data.price,
      productType: data.productType,
      saleType: data.saleType,
      paymentMethod: data.paymentMethod,
      paymentType: data.paymentType,
      splittable: data.splittable,
      isgroup: data.isgroup === "yes" ? 1 : 0,
      renter_owner: this.getFor(data.renter_owner),
      contents: this.getContents(data.contents),
      media: data.media,
    };

    if (data.address) {
      packageData.address = data.address;
    }

    if (data.productLogoFile) {
      const logoPath = await uploadFile(data.productLogoFile, this.path);
      if (logoPath) packageData.productLogo = logoPath;
    }

    await Firebase.addPackage(packageData);
    this.setState({ loading: false });
  };

  showEcoPackages = () => {
    let { packages } = this.state;
    return packages.map((item, index) => {
      return (
        <Fragment key={item.id}>
          <Package
            data={item}
            onClick={() => this.togglePackage(index)}
            onEdit={() => {
              this.setState({ selectedPackage: item });
            }}
            territory="UK"
          />
        </Fragment>
      );
    });
  };
  togglePackage = (index) => {
    const { packages } = this.state;
    let visibility = !packages[index].visibility;
    Firebase.updateGlobalPackage(packages[index].id, {
      visibility: visibility,
    });
  };

  editPackage = async (data) => {
    this.setState({ loading: true });
    const { selectedPackage } = this.state;

    let packageData = {
      caption: data.caption,
      description: data.description,
      price: data.price,
      productType: data.productType,
      saleType: data.saleType,
      paymentMethod: data.paymentMethod,
      paymentType: data.paymentType,
      splittable: data.splittable,
      address: data.isGeoLocated && data.address ? data.address : null,
      contents: this.getContents(data.contents),
      media: data.media,
      for: this.getFor(data.renter_owner),
      isgroup: data.isgroup === "yes" ? 1 : 0,
      threshold: parseInt(data.threshold),
    };

    // if no logo, add logo to product
    if (!selectedPackage.productLogo && data.productLogoFile) {
      const logoPath = await uploadFile(data.productLogoFile, this.path);
      if (logoPath) packageData.productLogo = logoPath;

      // if there is already a logo -> replace it
    } else if (selectedPackage.productLogo && data.productLogoFile) {
      // 1. delete old logo
      const path = getFilePath(
        "packages",
        selectedPackage.productLogo,
        IMAGE_UPLOAD
      );
      await Firebase.deleteFile(path);

      // 2. upload new logo
      const logoPath = await uploadFile(data.productLogoFile, this.path);
      if (logoPath) packageData.productLogo = logoPath;
    }

    // delete logo without replacement (triggers when users click delete X)
    else if (selectedPackage.productLogo && data.logoToDelete) {
      const path = getFilePath("packages", data.logoToDelete, IMAGE_UPLOAD);
      Firebase.deleteFile(path);
      packageData.productLogo = "";
    }

    await Firebase.updateEcoPackageById(selectedPackage.id, packageData);
    this.setState({
      loading: false,
    });
  };

  toggleView = (isMapOpen) => this.setState({ isMapOpen: isMapOpen });

  setHoveredLocation = (hoveredLocation) => {
    this.setState({ hoveredLocation: hoveredLocation });
  };

  render() {
    const {
      logo,
      brand,
      loading,
      selectedPackage,
      packages,
      isMapOpen,
      brandPrimaryHex,
    } = this.state;
    const username = this.props.location.state.username;
    const role = this.props.location.state.role;
    const ecoProductsWithAddress = packages.filter(
      (product) => product.address
    );

    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main
          id="main-container"
          style={{
            backgroundColor: isMapOpen ? "#252e3d" : "",
            margin: 0,
            padding: 20,
            transitionProperty: "background-color",
            transitionDuration: "300ms",
            minHeight: "95vh",
          }}
        >
          <div className="div_content">
            {loading && (
              <i
                className="fa fa-3x fa-sync fa-spin text-muted"
                style={{
                  position: "fixed",
                  left: "48%",
                  top: "48%",
                }}
              />
            )}
            {!loading && (
              <div className="super-products__wrapper">
                <div className="super-products__top-container">
                  <button
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-target="#package_popup"
                    style={{
                      width: 327,
                      height: 50,
                      fontSize: 20,
                    }}
                  >
                    + Add a new product
                  </button>
                  <div className="super-products__btn-container">
                    <button
                      className={`super-products__map-btn btn btn-white ${
                        isMapOpen ? "" : "super-products__map-btn--selected"
                      }`}
                      type="button"
                      onClick={() => this.toggleView(false)}
                    >
                      Product List
                    </button>
                    <button
                      className={`super-products__map-btn btn btn-white ${
                        isMapOpen ? "super-products__map-btn--selected" : ""
                      } ${
                        ecoProductsWithAddress.length
                          ? ""
                          : "super-products__map-btn--disabled"
                      }`}
                      type="button"
                      onClick={() => this.toggleView(true)}
                      disabled={!ecoProductsWithAddress.length}
                      title={
                        ecoProductsWithAddress.length
                          ? ""
                          : "Please add an address to a product to view the map"
                      }
                    >
                      <i className="fa fa-map-marker-alt" />
                      View Map
                    </button>
                  </div>
                </div>
                {isMapOpen && (
                  <MapViewer
                    productsWithAddress={ecoProductsWithAddress}
                    setHoveredLocation={this.setHoveredLocation}
                    initialZoom={
                      ecoProductsWithAddress.length === 1 ? 14 : null
                    }
                  />
                )}
              </div>
            )}
            {!loading && isMapOpen ? (
              <ProductCarousel
                productsWithAddress={ecoProductsWithAddress}
                hoveredLocation={this.state.hoveredLocation}
                sliderRef={this.sliderRef}
              />
            ) : !loading ? (
              this.showEcoPackages()
            ) : null}
          </div>
          <Popup
            addPackage={this.addPackage}
            territory={TerritoryOptions[0]}
            hex={brandPrimaryHex}
            white={false}
            brandId={0}
          />
          <EditPackage
            onEdit={this.editPackage}
            initialValue={selectedPackage}
            territory={TerritoryOptions[0]}
            hex={brandPrimaryHex}
            white={false}
            brandId={brand}
          />
          <ConfirmationModal
            id="remove_package"
            onClick={this.removePackage}
            type="package"
            classNames="super-products__confirm-btn"
            hex={brandPrimaryHex}
            white={true}
          />
        </main>
      </div>
    );
  }
}
export default SuperProducts;



// WEBPACK FOOTER //
// ./src/screens/super_products/index.js